import { stylesheet } from 'typestyle';
import { colors, font } from '../../assets/styles';

const styles = stylesheet({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '84px',
    padding: '0px 24px',
    color: colors.white,
    backgroundColor: colors.darkBlueBackground,
    zIndex: 5,
  },
  headerLeft: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerLeftIcon: {
    height: 24,
    width: 24,
    marginRight: 16,
  },
  headerText: {
    fontWeight: font.weight.regular,
    fontSize: 20,
  },
  headerRight: {
    textAlign: 'end',
  },
  infoIcon: {
    width: 40,
    height: 'auto',
  },
  buttonWithIcon: {
    border: 'none',
    display: 'flex',
    padding: '5px 10px',
    background: 'none',
    flexDirection: 'column',
    alignItems: 'center',
  },
  wrapper: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  verificationWrapper: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '30%',
  },
  title: {
   color: '#252b2e',
  fontSize: 18,
  lineHeight: '30px',
  },
  spacer: {
    padding: '15px 0 0 15px',
  },
  text: {
    color: colors.white,
    lineHeight: '24px',
    fontWeight: font.weight.light
  },
  errorWrapper: {
    color: 'red',
    fontSize: 14,
    padding: '0 20',
  }
});

export default styles;
